import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../services/auth";
import {
  PersonCircle,
  BoxArrowRight,
  Person,
  List,
} from "react-bootstrap-icons";
import "./Header.css";

const Header = ({ toggleMobileSidebar }) => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
    logout();
    localStorage.clear();
    navigate("/login");
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      <header className="admin-header">
        {/* LEFT */}
        <div className="header-left">
          <button className="mobile-menu-btn" onClick={toggleMobileSidebar}>
            <List />
          </button>
        </div>

        {/* RIGHT */}
        <div className="header-right" ref={dropdownRef}>
          <button
            className="user-dropdown-toggle"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <PersonCircle className="avatar-icon" />

            <span className="user-name">Admin</span>

            <span className={`dropdown-arrow ${showDropdown ? "open" : ""}`}>
              ▼
            </span>
          </button>

          {showDropdown && (
            <div className="user-dropdown">{/* dropdown items */}</div>
          )}

          {/* DROPDOWN */}
          {showDropdown && (
            <div className="user-dropdown">
              {/* <button
                className="dropdown-item-custom"
                onClick={() => {
                  setShowDropdown(false);
                  navigate("/profile");
                }}
              >
                <Person className="me-2" />
                Profile
              </button> */}

              {/* <div className="dropdown-divider-custom" /> */}

              <button
                className="dropdown-item-custom logout"
                onClick={() => {
                  setShowDropdown(false);
                  setShowLogoutConfirm(true);
                }}
              >
                <BoxArrowRight className="me-2" />
                Logout
              </button>
            </div>
          )}
        </div>
      </header>

      {/* LOGOUT CONFIRMATION */}
      {showLogoutConfirm && (
        <div className="modal-backdrop-custom">
          <div className="logout-modal">
            <h6>Confirm Logout</h6>
            <p>Are you sure you want to logout?</p>

            <div className="modal-actions">
              <button
                className="btn-cancel"
                onClick={() => setShowLogoutConfirm(false)}
              >
                Cancel
              </button>
              <button className="btn-logout" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
